// module
import React from 'react';
import { BrowserRouter , Route, Switch } from 'react-router-dom';
import { createBrowserHistory } from "history";

// my Components
import Header from "./components/Header";
import Navigation from "./components/Nav";
import Footer from "./components/Footer";

// my Routers
import Home from "./routes/Home";
import Manual from "./routes/Manual";
import Gaap01 from "./routes/Gaap01";
import Gaap02 from "./routes/Gaap02";
import Gaap03 from "./routes/Gaap03";
import Gaap03_AllPath from "./routes/Gaap03AllPath";
import Gaap03_Abyss from "./routes/Gaap03Abyss";
import Gaap03_Velvet from "./routes/Gaap03Velvet";
import Gaap03_Gap from "./routes/Gaap03Gap";
import Gaap04 from "./routes/Gaap04";
import Gaap05 from "./routes/Gaap05";
import Gaap06 from "./routes/Gaap06";
import Gaap07 from "./routes/Gaap07";
import Gaap08 from "./routes/Gaap08";
import Gaap09 from "./routes/Gaap09";
import Gaap10 from "./routes/Gaap10";
import Gaap11 from "./routes/Gaap11";

// css
import "./css/style.css"

const history = createBrowserHistory();

function App(){
  return (
    <BrowserRouter history={history}>
      <Navigation tall="900px"/>
      <Header />
      <Switch>
      <Route path="/" exact={true} component={Home} />
      <Route path="/manual" exact={true} component={Manual} />
      <Route path="/Gaap01" exact={true} component={Gaap01} />
      <Route path="/Gaap02" exact={true} component={Gaap02} />
      <Route path="/Gaap03" exact={true} component={Gaap03} />
      <Route path="/Gaap03_AllPath" exact={true} component={Gaap03_AllPath} />
      <Route path="/Gaap03_Abyss" exact={true} component={Gaap03_Abyss} />
      <Route path="/Gaap03_Velvet" exact={true} component={Gaap03_Velvet} />
      <Route path="/Gaap03_Gap" exact={true} component={Gaap03_Gap} />
      <Route path="/Gaap04" exact={true} component={Gaap04} />
      <Route path="/Gaap05" exact={true} component={Gaap05} />
      <Route path="/Gaap06" exact={true} component={Gaap06} />
      <Route path="/Gaap07" exact={true} component={Gaap07} />
      <Route path="/Gaap08" exact={true} component={Gaap08} />
      <Route path="/Gaap09" exact={true} component={Gaap09} />
      <Route path="/Gaap10" exact={true} component={Gaap10} />
      <Route path="/Gaap11" exact={true} component={Gaap11} />
      </Switch>
      <Footer/>      
    </BrowserRouter>
  );
}

export default App;